<div
  #trigger
  class="custom-tooltip-wrapper"
  (pointerenter)="onMouseEnter()"
  (mouseenter)="onMouseEnter()"
  (pointerleave)="onMouseLeave()"
  (mouseleave)="onMouseLeave()">
  <!-- Tooltip图标 -->
  <cds-icon class="tooltip-icon" icon="action:info_1" width="16px" height="16px" color="#6B7280"> </cds-icon>
</div>
